
export const DAYS_OF_WEEK = [
  { value: 1, label: "Monday" },
  { value: 2, label: "Tuesday" },
  { value: 3, label: "Wednesday" },
  { value: 4, label: "Thursday" },
  { value: 5, label: "Friday" },
  { value: 6, label: "Saturday" },
  { value: 7, label: "Sunday" },
];

// day_type (chk_day_type)
export const DAY_TYPE_OPTIONS = [
  { value: "FULL_DAY", label: "Full Day" },
  { value: "HALF_DAY", label: "Half Day" },
  { value: "HOLIDAY", label: "Holiday" },
];

// Compact labels for the inline per-week selector (WeekRow) — screenshot
// shows "Full / Half / Off" rather than the long wording used in
// DayTypeSelector. Values still map 1:1 to day_type.
export const SHORT_OPTIONS = [
  { value: "FULL_DAY", label: "Full" },
  { value: "HALF_DAY", label: "Half" },
  { value: "HOLIDAY", label: "Holiday" },
];

// week_number (chk_week_number) — 'All' plus custom weeks 1-5.
export const WEEK_NUMBERS = ["1", "2", "3", "4", "5"];

export const SCHEDULE_MODES = {
  ALL: "All",
  CUSTOM: "Custom",
};

// Default fallbacks used across the module (initial state, mappers) so
// "FULL_DAY" / "All" string literals aren't scattered across files.
export const DEFAULT_DAY_TYPE = "FULL_DAY";
export const ALL_WEEKS_KEY = "All";